import { MaskedLines, Reveal, Overline } from "./shared";

const LEVELS = [
    { title: "One Object", desc: "A small kinetic sculpture for a reception desk.", size: "text-2xl md:text-3xl", w: "w-16" },
    { title: "One Wall", desc: "A kinetic feature wall that anchors the room.", size: "text-3xl md:text-4xl", w: "w-32" },
    { title: "One Room", desc: "An immersive lighting environment.", size: "text-4xl md:text-5xl", w: "w-56" },
    { title: "One Building", desc: "A signature architectural installation.", size: "text-5xl md:text-7xl", w: "w-full" },
];

export const Scale = () => (
    <section data-testid="scale-section" className="relative py-32 md:py-48">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12">
            <Overline>Scale</Overline>
            <h2 className="mt-10 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl">
                <MaskedLines lines={["How big can", "you think?"]} />
            </h2>
            <div className="mt-24 space-y-0">
                {LEVELS.map((l, i) => (
                    <Reveal key={l.title} delay={i * 0.06}>
                        <div className="group border-t border-white/10 py-10 md:py-14">
                            <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
                                <h3 className={`font-display font-bold uppercase leading-none tracking-tight text-white transition-colors duration-700 group-hover:text-[#FFE8B6] ${l.size}`}>
                                    {l.title}
                                </h3>
                                <p className="max-w-xs text-sm font-light leading-relaxed text-white/55 md:text-base">{l.desc}</p>
                            </div>
                            <span className={`mt-8 block h-px bg-gradient-to-r from-[#FFE8B6]/60 to-transparent shadow-[0_0_12px_1px_rgba(255,214,140,0.25)] transition-[width] duration-1000 ${l.w}`} />
                        </div>
                    </Reveal>
                ))}
            </div>
            <Reveal className="mt-16 max-w-xl">
                <p className="text-lg font-light leading-relaxed text-white/60 md:text-xl">
                    There is no standard installation. Every space gets its own idea.
                </p>
            </Reveal>
        </div>
    </section>
);
